<template>
  <div class="media-view">
    <!-- video -->
    <el-image
      v-if="[2, 4].includes(mediaClassId) && previewSrc"
      :style="{ width, height }"
      :src="src"
      class="cover-img"
      fit="contain"
      title="点击预览"
      @click="openPreview"
    ></el-image>
    <!-- image -->
    <el-image
      v-else
      :style="{ width, height }"
      :src="src"
      :preview-src-list="[src]"
      class="cover-img"
      fit="contain"
      title="点击预览"
    ></el-image>
    <el-dialog title="预览" :visible.sync="showPreview" append-to-body destroy-on-close>
      <video class="preview-video" controls width="100%" autoplay>
        <source :src="previewSrc" />
      </video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    mediaClassId: {
      type: Number,
      default: 1
    },
    width: {
      type: String,
      default: '100px'
    },
    height: {
      type: String,
      default: '100px'
    },
    src: {
      type: String,
      default: ''
    },
    previewSrc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPreview: false
    }
  },
  methods: {
    openPreview() {
      this.showPreview = true
    }
  }
}
</script>

<style lang="stylus" scoped>
.media-view
  display inline-block
  line-height 0
  &:not(:last-child)
    margin-right 16px
  .cover-img
    cursor pointer
.preview-video
  display block
>>>.el-dialog__body
  padding-top 6px!important
</style>
